import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { PrimaryButton } from "../../../common/components/CustomButton";
import Modal from "../../../common/components/Modal";
import { Box } from "@mui/system";
import CustomAutocomplete from "../../../common/components/CustomAutocomplete";
import { useRtkQueryDynamicEndpoint } from "../../../common/hooks/useRtkQueryDynamicEndpoint";
import { useLazyGetContactsQuery } from "../../../requests_cm/gecoReferentialService/service";
import { Formik } from "formik";
import { ContactType } from "../../../requests_cm/gecoReferentialService/types";
import { Spacer } from "../../../common/components/Spacer";
import { useMemo } from "react";
import {
	ErrorType,
	formatApiErrorMessage,
} from "../../../common/utils/formatApiErrorMessage";
import ErrorMessageModal from "../../../common/components/ErrorMessageDialog";

const AddContactModal = ({
	isOpen,
	onClose,
	addContact,
}: {
	isOpen: boolean;
	onClose: () => void;
	addContact: (contact: Pick<ContactType, "id" | "name">) => void;
}) => {
	const [getContactsBase, { isLoading, error: errorMessage, data }] =
		useLazyGetContactsQuery();

	const getContacts = useRtkQueryDynamicEndpoint(getContactsBase);

	const contacts = useMemo(() => data?.result || [], [data]);

	return (
		<>
			<Modal
				onClose={onClose}
				open={isOpen}
				title={
					<Box
						sx={{
							display: "flex",
							gap: "8px",
							alignItems: "center",
						}}
					>
						<PersonAddIcon /> Add contact
					</Box>
				}
			>
				<Formik
					initialValues={{
						contact: { id: "", name: "" },
					}}
					onSubmit={(values) => {
						addContact({
							id: Number(values.contact.id),
							name: values.contact.name,
						});
					}}
				>
					{({ setFieldValue, submitForm }) => (
						<form>
							<CustomAutocomplete
								data={contacts ?? []}
								loading={isLoading}
								fetchData={(search: string) =>
									getContacts({ search__email: search })
								}
								label="eMail Address"
								setFieldValue={(event, value) => {
									setFieldValue("contact", value);
								}}
							/>
							<Spacer gap={24} />
							<Box sx={{ display: "flex", gap: "16px" }}>
								<PrimaryButton
									color="secondary"
									text="Cancel"
									onClick={onClose}
									type="button"
								/>
								<PrimaryButton
									text="Done"
									type="button"
									onClick={() => {
										submitForm();
										onClose();
									}}
								/>
							</Box>
						</form>
					)}
				</Formik>
			</Modal>
			<ErrorMessageModal
				title={"Failed to search the contact"}
				content={formatApiErrorMessage(errorMessage as ErrorType)}
			/>
		</>
	);
};

export default AddContactModal;
